import React from 'react';
import { Button } from '@lmig/lmds-react-button';
import './LMDSButton.scss';

interface IButtonProps {
    text: string;
    url: string;
    target?: string;
    isPrimary?: boolean;
}

const LMDSButton: React.FC<IButtonProps> = ({ text, url, target, isPrimary }) => {
    return url && text ? (
        <Button
            size="medium"
            variant={isPrimary ? "primary" : "secondary"}
            href={url}
            target={target}>
            {text}
        </Button>
    ) : <></>
};

export default LMDSButton;